"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzSelect = void 0;

var react_1 = __importDefault(require("react"));

var react_select_1 = __importStar(require("react-select"));

var SzCheckbox_1 = __importDefault(require("../SzCheckbox/SzCheckbox"));

var classnames_1 = __importDefault(require("classnames"));

var SzSelect_style_1 = __importDefault(require("./SzSelect.style"));

var SzSelect_style_outlined_1 = __importDefault(require("./SzSelect.style.outlined"));

var SzList_1 = __importDefault(require("../SzList/SzList"));

var SzData_1 = __importDefault(require("../SzData/SzData"));

require("./SzSelect.scss");

exports.SzSelect = function (props) {
  var className = props.className,
      isMultiList = props.isMultiList,
      error = props.error,
      small = props.small,
      border = props.border,
      variant = props.variant,
      value = props.value,
      leftProps = __rest(props, ["className", "isMultiList", "error", "small", "border", "variant", "value"]);

  var variantOutlined = variant && 'outlined' === variant;
  var styles = variantOutlined ? SzSelect_style_outlined_1.default : SzSelect_style_1.default;
  var classNamePrefix = classnames_1.default({
    'sz-select': !variant,
    'sz-select-outlined': variantOutlined
  });
  var selectClassName = classnames_1.default({
    'sz-select': !variant,
    'sz-select-outlined': variantOutlined,
    'border-soft': variant && !border || 'soft' === border,
    'border-rounded': 'rounded' === border,
    'select-small': small,
    'border-danger': error
  }, className);

  var Option = function Option(props) {
    var innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        data = props.data,
        isSelected = props.isSelected;
    var label = data.label,
        text = data.text,
        value = data.value;

    var Text = function Text() {
      return react_1.default.createElement(SzData_1.default, {
        className: "w-100 px-4 py-3"
      }, react_1.default.createElement(SzData_1.default.Title, null, label), text && react_1.default.createElement(SzData_1.default.Text, null, text));
    };

    return !isDisabled ? react_1.default.createElement(SzList_1.default.Item, __assign({}, innerProps, {
      className: "cursor-pointer p-0"
    }), isMultiList ? react_1.default.createElement(SzCheckbox_1.default, {
      className: "d-flex align-items-center w-100",
      name: value,
      label: react_1.default.createElement(Text, null),
      checked: isSelected
    }) : react_1.default.createElement(Text, null)) : null;
  };

  var MenuList = function MenuList(props) {
    return react_1.default.createElement(react_select_1.components.MenuList, __assign({}, props), react_1.default.createElement(SzList_1.default, {
      className: "px-3"
    }, props.children));
  };

  var filterOption = function filterOption(_a, search) {
    var data = _a.data;
    var label = data.label,
        _b = data.text,
        text = _b === void 0 ? '' : _b;

    if (search.length === 0) {
      return true;
    }

    return label.toLowerCase().includes(search) || text.toLowerCase().includes(search);
  };

  return react_1.default.createElement(react_select_1.default, __assign({
    hideSelectedOptions: !isMultiList,
    closeMenuOnSelect: !isMultiList,
    components: {
      Option: Option,
      MenuList: MenuList
    },
    filterOption: filterOption,
    styles: styles,
    className: selectClassName,
    classNamePrefix: classNamePrefix
  }, leftProps));
};

exports.default = exports.SzSelect;